/**
 * @owner @Appboy/whats-app
 * WhatsApp Response Message GET Schema
 *
 * This schema is specifically for response messages (whats_app_message_type = "response").
 * Used for type narrowing in validators.
 */

import { z } from "zod";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { whatsAppMessagingServiceSchema } from "./whatsAppMessagingServiceSchema";
import { buildWhatsAppResponseSchemas } from "@schemas/message/whatsAppResponseMessageLayouts";
import type { WhatsAppLayoutDiscriminatedUnion } from "./types";

const responseGetSchemas = buildWhatsAppResponseSchemas({
  ...messageGetBaseSchema.shape,
  selected_messaging_service: whatsAppMessagingServiceSchema,
});

export const whatsAppResponseMessageGetSchema = z.discriminatedUnion(
  "layout",
  responseGetSchemas
) satisfies WhatsAppLayoutDiscriminatedUnion;
